import React from 'react';
interface StatusToggleProps {
  selected: string;
  onChange: (status: string) => void;
}
export function StatusToggle({
  selected,
  onChange
}: StatusToggleProps) {
  const options = ['All', 'New', 'Attempted', 'Connected', 'Converted'];
  return <div className="inline-flex bg-slate-100 rounded-lg p-1" data-id="element-195">
      {options.map(option => <button key={option} onClick={() => onChange(option)} className={`px-4 py-2 rounded-md text-sm font-medium transition-all ${selected === option ? 'bg-brand-orange-500 text-white shadow-sm' : 'text-slate-700 hover:text-slate-900'}`} data-id="element-196">
          {option}
        </button>)}
    </div>;
}